import React from 'react';
import { Text, Button, TextInput } from '..';
import Select from 'react-dropdown-select';
import { colors } from '../../../stylesheets';

const ListFooter = ({
  nextPage,
  canNextPage,
  pageCount,
  pageIndex,
  gotoPage,
  pageSize,
  setPageSize,
  previousPage,
  canPreviousPage,
}) => {
  return (
    <div className="list-footer pb-4">
      <div className="bg-backgroundGray b-lighterPrimary mt-3 p-3 radius-sm d-flex flex-center-between">
        <Button
          className="p-2 pr-3 radius-xlg w-2 h-2"
          size="sm"
          icon="arrow-right"
          iconSize={18}
          onClick={() => nextPage()}
          type="primary"
          // text="صفحه بعد"
          disabled={!canNextPage}
        />

        <div className="d-flex flex-center-center">
          <div className="d-flex flex-center-center ml-4">
            <Text size="lg" color="black" className="ml-1">
              {pageCount} /
            </Text>
            <TextInput
              // label="شماره صفحه"
              // labelClassName="text-center font-xsm"
              inputClassName="font-md"
              className="w-5"
              type="number"
              name="pageIndex"
              value={pageIndex + 1}
              onChange={(e) => gotoPage(e.target.value - 1)}
            />
          </div>
          <Select
            dropdownHandle
            values={[{ id: pageSize, value: pageSize }]}
            options={[
              { id: 10, value: 10 },
              { id: 20, value: 20 },
              { id: 30, value: 30 },
              { id: 40, value: 40 },
              { id: 50, value: 50 },
            ]}
            labelField="id"
            valueField="value"
            placeholder="تعداد"
            keepSelectedInList
            color={colors.primary}
            dropdownPosition="auto"
            searchable={false}
            noDataRenderer={() => {}}
            onChange={([item]) => setPageSize(item?.value)}
            closeOnSelect
            className="py-1 pr-2 radius-sm flex-row-reverse font-xsm"
          />
        </div>

        <Button
          className="ltr p-2 pl-3 radius-xlg w-2 h-2"
          size="sm"
          icon="arrow-right icon-rotate-180"
          iconSize={18}
          onClick={() => previousPage()}
          type="primary"
          // text="صفحه قبل"
          disabled={!canPreviousPage}
        />
      </div>
    </div>
  );
};

export default ListFooter;
